"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConstructorContextState = void 0;

var _react = require("react");

var _constructorContext = require("../constructorContext");

var useConstructorContextState = function useConstructorContextState() {
  var _useContext = (0, _react.useContext)(_constructorContext.constructorContext),
      state = _useContext.state;

  return state;
};

exports.useConstructorContextState = useConstructorContextState;